// // client/src/components/settings/PushNotificationSettings.jsx
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Bell, BellOff, Send } from "lucide-react";
// import { sessionRequestConfig } from '../../services/sessionLocal';

// const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

// export default function PushNotificationSettings({ showTestButton = true, onStatusChange }) {
//   const [enabled, setEnabled] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [busy, setBusy] = useState(false);
//   const [status, setStatus] = useState("");
//   const [permission, setPermission] = useState(Notification?.permission || "default");

//   useEffect(() => {
//     checkStatus();
//   }, []);

//   const checkStatus = async () => {
//     setLoading(true);
//     try {
//       // Check browser permission
//       const browserPermission = Notification?.permission || "default";
//       setPermission(browserPermission);

//       // Check backend subscription status
//       const res = await axios.get(
//         `${baseUrl}/api/notifications/push/status`,
//         sessionRequestConfig()
//       );

//       const isEnabled = res.data?.isEnabled || res.data?.hasSubscription || false;
//       setEnabled(isEnabled);
//       onStatusChange?.(isEnabled);

//     } catch (error) {
//       console.error("Error checking notification status:", error);
//       setEnabled(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const enableNotifications = async () => {
//     setBusy(true);
//     setStatus("");

//     try {
//       // Request browser permission
//       const permission = await Notification.requestPermission();
//       setPermission(permission);

//       if (permission !== "granted") {
//         setStatus("Permission denied. Please enable notifications in your browser settings.");
//         setTimeout(() => setStatus(""), 5000);
//         return;
//       }

//       // Register service worker
//       if (!("serviceWorker" in navigator)) {
//         setStatus("Service workers not supported in this browser");
//         setTimeout(() => setStatus(""), 3000);
//         return;
//       }

//       const registration = await navigator.serviceWorker.ready;

//       // Get VAPID public key from backend
//       const vapidRes = await axios.get(
//         `${baseUrl}/api/notifications/push/vapid-public-key`
//       );

//       if (!vapidRes.data?.publicKey) {
//         setStatus("Push notifications not configured on server");
//         setTimeout(() => setStatus(""), 3000);
//         return;
//       }

//       // Subscribe to push notifications
//       const subscription = await registration.pushManager.subscribe({
//         userVisibleOnly: true,
//         applicationServerKey: vapidRes.data.publicKey,
//       });

//       // Send subscription to backend
//       await axios.post(
//         `${baseUrl}/api/notifications/push/subscribe`,
//         { subscription },
//         sessionRequestConfig()
//       );

//       setEnabled(true);
//       setStatus("Notifications enabled successfully!");
//       onStatusChange?.(true);
//       setTimeout(() => setStatus(""), 3000);

//     } catch (error) {
//       console.error("Error enabling notifications:", error);
//       setStatus(`Error: ${error.response?.data?.error || error.message}`);
//       setTimeout(() => setStatus(""), 5000);
//     } finally {
//       setBusy(false);
//     }
//   };

//   const disableNotifications = async () => {
//     setBusy(true);
//     setStatus("");

//     try {
//       const registration = await navigator.serviceWorker.ready;
//       const subscription = await registration.pushManager.getSubscription();

//       if (subscription) {
//         // Unsubscribe from push
//         await subscription.unsubscribe();

//         // Remove from backend
//         await axios.post(
//           `${baseUrl}/api/notifications/push/unsubscribe`,
//           { subscription },
//           sessionRequestConfig()
//         );
//       }

//       setEnabled(false);
//       setStatus("Notifications disabled");
//       onStatusChange?.(false);
//       setTimeout(() => setStatus(""), 3000);

//     } catch (error) {
//       console.error("Error disabling notifications:", error);
//       setStatus(`Error: ${error.message}`);
//       setTimeout(() => setStatus(""), 5000);
//     } finally {
//       setBusy(false);
//     }
//   };

//   const sendTestNotification = async () => {
//     setBusy(true);
//     setStatus("");

//     try {
//       await axios.post(
//         `${baseUrl}/api/notifications/push/test`,
//         {},
//         sessionRequestConfig()
//       );

//       setStatus("Test notification sent! Check your notifications.");
//       setTimeout(() => setStatus(""), 3000);

//     } catch (error) {
//       console.error("Error sending test:", error);
//       setStatus(`Error: ${error.response?.data?.error || error.message}`);
//       setTimeout(() => setStatus(""), 5000);
//     } finally {
//       setBusy(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ padding: "20px", textAlign: "center" }}>
//         <p>Loading notification settings...</p>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* Status Message */}
//       {status && (
//         <div
//           style={{
//             marginBottom: "16px",
//             padding: "12px",
//             borderRadius: "8px",
//             backgroundColor: status.includes("Error") ? "#fee2e2" : "#d1fae5",
//             color: status.includes("Error") ? "#991b1b" : "#065f46",
//             fontSize: "14px",
//           }}
//         >
//           {status}
//         </div>
//       )}

//       {/* Browser Permission Status */}
//       {permission === "denied" && (
//         <div
//           style={{
//             marginBottom: "16px",
//             padding: "12px",
//             borderRadius: "8px",
//             backgroundColor: "#fef3c7",
//             color: "#92400e",
//             fontSize: "14px",
//           }}
//         >
//           <strong>⚠️ Notifications blocked</strong>
//           <p style={{ margin: "8px 0 0", fontSize: "13px" }}>
//             Notifications are blocked in your browser. Please enable them in your browser settings.
//           </p>
//         </div>
//       )}

//       {/* Enable/Disable Toggle */}
//       <div className="form-group">
//         <label style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
//           {enabled ? (
//             <Bell style={{ width: "20px", height: "20px", color: "#10b981" }} />
//           ) : (
//             <BellOff style={{ width: "20px", height: "20px", color: "#6b7280" }} />
//           )}
//           <span style={{ fontWeight: "600" }}>Push Notifications</span>
//           <span
//             style={{
//               marginLeft: "auto",
//               fontSize: "12px",
//               padding: "2px 8px",
//               borderRadius: "12px",
//               backgroundColor: enabled ? "#d1fae5" : "#e5e7eb",
//               color: enabled ? "#065f46" : "#6b7280",
//             }}
//           >
//             {enabled ? "Enabled" : "Disabled"}
//           </span>
//         </label>

//         <p style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>
//           Receive instant notifications for messages, mentions, and updates
//         </p>

//         {enabled ? (
//           <button
//             type="button"
//             className="btn btn-outline-danger"
//             onClick={disableNotifications}
//             disabled={busy}
//             style={{ width: "100%" }}
//           >
//             {busy ? "Disabling..." : "Disable Notifications"}
//           </button>
//         ) : (
//           <button
//             type="button"
//             className="btn btn-primary"
//             onClick={enableNotifications}
//             disabled={busy || permission === "denied"}
//             style={{ width: "100%" }}
//           >
//             {busy ? "Enabling..." : "Enable Notifications"}
//           </button>
//         )}
//       </div>

//       {/* Test Button */}
//       {showTestButton && enabled && (
//         <div className="form-group" style={{ marginTop: "16px" }}>
//           <button
//             type="button"
//             className="btn btn-outline-primary"
//             onClick={sendTestNotification}
//             disabled={busy}
//             style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
//           >
//             <Send style={{ width: "16px", height: "16px" }} />
//             {busy ? "Sending..." : "Send Test Notification"}
//           </button>
//         </div>
//       )}

//       {/* Browser Compatibility Note */}
//       {!("Notification" in window) && (
//         <p style={{ fontSize: "13px", color: "#666", marginTop: "12px", fontStyle: "italic" }}>
//           ⚠️ Push notifications are not supported in your browser
//         </p>
//       )}
//     </div>
//   );
// }

// client/src/components/settings/PushNotificationSettings.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Bell, BellOff, Send } from "lucide-react";
import { sessionRequestConfig, getSessionLocal } from '../../services/sessionLocal';

const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

/**
 * Convert a base64url VAPID key to Uint8Array for pushManager.subscribe()
 */
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default function PushNotificationSettings({ showTestButton = true, onStatusChange }) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState("");
  const [permission, setPermission] = useState(Notification?.permission || "default");

  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    const session = getSessionLocal();
    if (!session.userId) {
      // No user session yet — skip API call, show as disabled
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      // Check browser permission
      const browserPermission = Notification?.permission || "default";
      setPermission(browserPermission);

      // Check backend subscription status
      const res = await axios.get(
        `${baseUrl}/api/notifications/push/status`,
        sessionRequestConfig()
      );

      const isEnabled = res.data?.isEnabled || res.data?.hasSubscription || false;
      setEnabled(isEnabled);
      onStatusChange?.(isEnabled);

    } catch (error) {
      console.error("Error checking notification status:", error);
      setEnabled(false);
    } finally {
      setLoading(false);
    }
  };

  const enableNotifications = async () => {
    setBusy(true);
    setStatus("");

    try {
      // Request browser permission
      const permission = await Notification.requestPermission();
      setPermission(permission);

      if (permission !== "granted") {
        setStatus("Permission denied. Please enable notifications in your browser settings.");
        setTimeout(() => setStatus(""), 5000);
        return;
      }

      // Register service worker
      if (!("serviceWorker" in navigator)) {
        setStatus("Service workers not supported in this browser");
        setTimeout(() => setStatus(""), 3000);
        return;
      }

      const registration = await navigator.serviceWorker.ready;

      // Get VAPID public key from backend
      const vapidRes = await axios.get(
        `${baseUrl}/api/notifications/push/vapid-public-key`
      );

      if (!vapidRes.data?.publicKey) {
        setStatus("Push notifications not configured on server");
        setTimeout(() => setStatus(""), 3000);
        return;
      }

      // Subscribe to push notifications (convert VAPID key to Uint8Array for browser compatibility)
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidRes.data.publicKey),
      });

      // Send subscription to backend
      await axios.post(
        `${baseUrl}/api/notifications/push/subscribe`,
        { subscription },
        sessionRequestConfig()
      );

      // Save user preference to server (persists across devices)
      await axios.put(
        `${baseUrl}/api/notifications/push/preference`,
        { enabled: true },
        sessionRequestConfig()
      );

      setEnabled(true);
      setStatus("Notifications enabled successfully!");
      onStatusChange?.(true);
      setTimeout(() => setStatus(""), 3000);

    } catch (error) {
      console.error("Error enabling notifications:", error);
      setStatus(`Error: ${error.response?.data?.error || error.message}`);
      setTimeout(() => setStatus(""), 5000);
    } finally {
      setBusy(false);
    }
  };

  const disableNotifications = async () => {
    setBusy(true);
    setStatus("");

    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();

      if (subscription) {
        // Unsubscribe from push
        await subscription.unsubscribe();

        // Remove from backend
        await axios.post(
          `${baseUrl}/api/notifications/push/unsubscribe`,
          { subscription },
          sessionRequestConfig()
        );
      }

      // Save user preference to server (persists across devices)
      await axios.put(
        `${baseUrl}/api/notifications/push/preference`,
        { enabled: false },
        sessionRequestConfig()
      );

      setEnabled(false);
      setStatus("Notifications disabled");
      onStatusChange?.(false);
      setTimeout(() => setStatus(""), 3000);

    } catch (error) {
      console.error("Error disabling notifications:", error);
      setStatus(`Error: ${error.message}`);
      setTimeout(() => setStatus(""), 5000);
    } finally {
      setBusy(false);
    }
  };

  const maskEmail = (addr) => {
    if (!addr || !addr.includes("@")) return addr || "";
    const [user, domain] = addr.split("@");
    const head = user.length <= 2 ? user[0] || "" : user.slice(0, 2);
    return `${head}${"*".repeat(Math.max(1, user.length - head.length))}@${domain}`;
  };

  const sendTestNotification = async () => {
    setBusy(true);
    setStatus("");

    try {
      const res = await axios.post(
        `${baseUrl}/api/notifications/push/test`,
        {},
        sessionRequestConfig()
      );

      const { push = {}, email = {} } = res.data || {};
      const pushMsg = push.sent > 0
        ? `Push: sent`
        : `Push: ${push.skipped || push.error || "not delivered"}`;
      const emailMsg = email.sent
        ? `Email: sent to ${maskEmail(email.to)}`
        : `Email: ${email.error || "not sent"}`;
      setStatus(`${pushMsg} · ${emailMsg}`);
      setTimeout(() => setStatus(""), 6000);

    } catch (error) {
      console.error("Error sending test:", error);
      setStatus(`Error: ${error.response?.data?.error || error.message}`);
      setTimeout(() => setStatus(""), 5000);
    } finally {
      setBusy(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p>Loading notification settings...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Status Message */}
      {status && (
        <div
          style={{
            marginBottom: "16px",
            padding: "12px",
            borderRadius: "8px",
            backgroundColor: status.includes("Error") ? "#fee2e2" : "#d1fae5",
            color: status.includes("Error") ? "#991b1b" : "#065f46",
            fontSize: "14px",
          }}
        >
          {status}
        </div>
      )}

      {/* Browser Permission Status */}
      {permission === "denied" && (
        <div
          style={{
            marginBottom: "16px",
            padding: "12px",
            borderRadius: "8px",
            backgroundColor: "#253866",
            color: "#fff",
            fontSize: "14px",
          }}
        >
          <strong>⚠️ Notifications blocked</strong>
          <p style={{ margin: "8px 0 0", fontSize: "13px" }}>
            Notifications are blocked in your browser. Please enable them in your browser settings.
          </p>
        </div>
      )}

      {/* Enable/Disable Toggle */}
      <div className="form-group">
        <label style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
          {enabled ? (
            <Bell style={{ width: "20px", height: "20px", color: "#10b981" }} />
          ) : (
            <BellOff style={{ width: "20px", height: "20px", color: "#6b7280" }} />
          )}
          <span style={{ fontWeight: "600" }}>Push Notifications</span>
          <span
            style={{
              marginLeft: "auto",
              fontSize: "12px",
              padding: "2px 8px",
              borderRadius: "12px",
              backgroundColor: enabled ? "#253866" : "#475569",
              color: "#fff",
            }}
          >
            {enabled ? "Enabled" : "Disabled"}
          </span>
        </label>

        <p className="text-muted" style={{ fontSize: "14px", marginBottom: "12px" }}>
          Receive instant notifications for messages, mentions, and updates
        </p>

        {enabled ? (
          <button
            type="button"
            className="btn btn-outline-danger"
            onClick={disableNotifications}
            disabled={busy}
            style={{ width: "100%" }}
          >
            {busy ? "Disabling..." : "Disable Notifications"}
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-primary"
            onClick={enableNotifications}
            disabled={busy || permission === "denied"}
            style={{ width: "100%" }}
          >
            {busy ? "Enabling..." : "Enable Notifications"}
          </button>
        )}
      </div>

      {/* Test Button */}
      {showTestButton && enabled && (
        <div className="form-group" style={{ marginTop: "16px" }}>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={sendTestNotification}
            disabled={busy}
            style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
          >
            <Send style={{ width: "16px", height: "16px" }} />
            {busy ? "Sending..." : "Send Test Notification"}
          </button>
        </div>
      )}

      {/* Browser Compatibility Note */}
      {!("Notification" in window) && (
        <p style={{ fontSize: "13px", color: "#666", marginTop: "12px", fontStyle: "italic" }}>
          ⚠️ Push notifications are not supported in your browser
        </p>
      )}
    </div>
  );
}